import { Box, BoxProps, Flex, Spacer } from "@chakra-ui/react";
import { ReactNode, forwardRef } from "react";

import { RanaColorPath, RanaHeading } from "@nens/ranalib";

interface OverviewBlockProps extends BoxProps {
  color?: RanaColorPath;
  title?: string;
  rightLink?: ReactNode;
}

export const ContentPanel = forwardRef<HTMLDivElement, OverviewBlockProps>((props, ref?) => {
  const { title, rightLink, children, color = "brand.deep_sea", bg = "brand.bg", ...rest } = props;
  return (
    <Flex
      ref={ref}
      direction="column"
      overflow="hidden"
      w="full"
      h="full"
      color={color}
      borderWidth="base"
      rounded="base"
      bg={bg}
    >
      {title ? (
        <Flex
          padding={4}
          borderBottomWidth="base"
          whiteSpace="nowrap"
          alignItems="center"
          color={color}
        >
          <RanaHeading type="h6" padding={0} margin={0}>
            {title}
          </RanaHeading>
          <Spacer mx={1} />
          {rightLink}
        </Flex>
      ) : null}
      <Box h="full" padding={4} overflow="auto" color={color} textStyle="sm" {...rest}>
        {children}
      </Box>
    </Flex>
  );
});

ContentPanel.displayName = "ContentPanel";
